import LegalLayout from "@/components/LegalLayout";
import { Mail } from "lucide-react";

const SUPPORT_EMAIL = "support@lyriclock.com";

export default function Contact() {
  return (
    <LegalLayout title="Contact" updated="February 2026" testid="contact-page">
      <section>
        <p>
          Feedback, bug reports, privacy questions, or just a hello — we read every note.
        </p>
      </section>

      <section>
        <h2 className="font-display text-2xl md:text-3xl mb-3">Email us</h2>
        <a
          href={`mailto:${SUPPORT_EMAIL}`}
          className="inline-flex items-center gap-2 mt-2 px-5 py-3 rounded-full border border-primary/40 text-primary bg-primary/5 hover:bg-primary/10 transition-colors font-mono text-sm"
          data-testid="contact-email-link"
        >
          <Mail size={16} /> {SUPPORT_EMAIL}
        </a>
        <p className="mt-6 text-sm text-muted-foreground">
          We reply within a few business days. For privacy or account-deletion requests, please
          include the email address you registered with.
        </p>
      </section>
    </LegalLayout>
  );
}
